const messages: Record<string, string> = {
	'vehicleRegistrationDocument.title': 'Permís de circulació del vehicle',
	'vehicleRegistrationDocument.description':
		'Puja fotos clares de les cares sol·licitades del permís de circulació.',
	'vehicleRegistrationDocument.RegistrationDocument.title': 'Anvers del permís de circulació',
	'vehicleRegistrationDocument.RegistrationDocument.description':
		"Fes una foto clara de l'anvers del permís de circulació.",
	'vehicleRegistrationDocument.RegistrationDocument.headline': 'Anvers del permís de circulació',
	'vehicleRegistrationDocument.RegistrationDocument.exampleModalTitle':
		'Anvers del permís de circulació - exemple',
	'vehicleRegistrationDocument.RegistrationDocument.validationRequired':
		'Anvers del permís de circulació',
	'vehicleRegistrationDocument.RegistrationDocumentInside.title': 'Revers del permís de circulació',
	'vehicleRegistrationDocument.RegistrationDocumentInside.description':
		'Fes una foto clara del revers del permís de circulació.',
	'vehicleRegistrationDocument.RegistrationDocumentInside.headline':
		'Revers del permís de circulació',
	'vehicleRegistrationDocument.RegistrationDocumentInside.exampleModalTitle':
		'Revers del permís de circulació - exemple',
	'vehicleRegistrationDocument.RegistrationDocumentInside.validationRequired':
		'Revers del permís de circulació',
	'vehicleRegistrationDocument.validationHeadline': 'Falten fotos',
	'vehicleRegistrationDocument.validationDescription': 'Afegeix les fotos següents:',
	'landing.stepDescription.vehicleRegistrationDocument': 'Fes fotos del permís de circulació',
	'review.stepDescription.vehicleRegistrationDocument': 'Permís de circulació del vehicle',
	'landing.changeLang': "Per canviar l'idioma, feu clic aquí.",
	'chooseLang.headline': 'Trieu el vostre idioma preferit',
	'blockedByDevice.headline': "PolicyCheck no admet navegadors d'escriptori",
	'blockedByDevice.description':
		"PolicyCheck utilitza un navegador d’escriptori.\r\nLa plataforma PolicyCheck realitza la documentació de casos mitjançant dispositius mòbils.\r\nPer continuar, executeu l'enllaç PolicyCheck en un dispositiu mòbil.",
	'button.accept': 'Acceptar',
	'button.addLater': 'Afegir més tard',
	'button.changeImage': 'Canviar la foto',
	'button.continue': 'Continuar',
	'button.close': 'Tancar',
	'button.deleteImage': 'Eliminar la foto',
	'button.next': 'Següent »',
	'button.ok': "D'acord",
	'button.prev': 'Tornar',
	'button.start': 'Començar',
	'completeVehicleInformationModal.description': 'Afegeix la informació següent:',
	'completeVehicleInformationModal.headline': 'Indicació',
	'completeVehicleInformationModal.isRegistrationDocumentUploaded':
		'Fotografia de la carta groga del vehicle',
	'dataPrivacyModal.headline': 'Termes i condicions',
	'editPhoto.edit': 'Canviar',
	'imageRecognitionFeedback2.exemplaryPhoto': 'Fotografia exemple',
	'landing.dataPrivacyLink': 'Accepta els termes i condicions',
	'landing.headline.policyCheck': 'Inspecció del cotxe en pocs passos:',
	'landing.paragraph':
		'Hola, estàs a punt d’iniciar el procés d’inspecció digital del teu vehicle. Fes les fotos seguint les instruccions . T’ocuparà poc temps. Important fer les fotos amb la llum del dia i amb el vehicle net.',
	'landing.termsAndConditionsLink': 'Accepta els termes i condicions',
	'landing.termsAndConditionsLinkDescription':
		'Per començar, accepta els termes i condicions i fes clic a següent.',
	'landing.aboutPolicyCheck': 'Què és PolicyCheck?',
	'landing.stepDescription.fourDiagonalPerspectives': 'Fes les fotografies necessàries',
	'landing.stepDescription.fourAdditionalPictures': 'Puja-les',
	'landing.stepDescription.feedback': "Dona'ns la teva opinió",
	'loader.loading': "S'estan carregant les dades ...",
	'vehicleInformation.headline.first': 'Detalls del vehicle',
	'vehicleInformation.headline.second': 'Foto de la carta groga (la cara)',
	'vehicleInformation.paragraph.first': 'Fotografia de la carta groga (la cara) ',
	'vehicleInformation.button.next': 'Següent »',
	'fourAdditionalPictures.mileage.description':
		'Fes una fotografia del quadre de comandament amb el quilometratge totalment visible. Si el teu vehicle té pantalles electròniques, activa-les.',
	'dashboardMileage.dashboard.paragraph':
		'Fes una fotografia del quadre de comandament amb el quilometratge totalment visible. Si el teu vehicle té pantalles electròniques, activa-les.',
	'fourAdditionalPictures.mileage.enter': 'Quilometratge del vehicle.',
	'dashboardMileage.paragraph.first': 'Quilometratge del vehicle.',
	'fourAdditionalPictures.mileage.title': 'Quilometratge',
	'fourAdditionalPictures.overallDashboard.description':
		'Fotografia la part frontal interior del teu vehicle',
	'fourAdditionalPictures.overallDashboard.title':
		'Imatge general de la part frontal interior del teu vehicle',
	'fourAdditionalPictures.title': 'Imatges addicionals',
	'fourAdditionalPictures.vin.description': 'Fes una foto del número VIN',
	'fourAdditionalPictures.vin.title': 'Fotografia del numero VIN (Núm. Xassis)',
	'fourAdditionalPictures.windshield.description': 'Si us plau, fes una fotografia del parabrisa.',
	'fourAdditionalPictures.windshield.title': 'Imatge del parabrisa',
	'fourAdditionalPicturesExampleModal.headline.first': 'Exemples',
	'fourAdditionalPicturesExampleModal.button.close': 'Tancar',
	'fourAdditionalPictures.overallDashboard.exampleModalTitle': 'Fotografia exemple',
	'fourAdditionalPictures.dashboard.exampleModalTitle': 'Fotografia exemple',
	'fourAdditionalPictures.windshield.exampleModalTitle': 'Fotografia exemple',
	'fourAdditionalPictures.vin.exampleModalTitle': 'Fotografia exemple',

	'completeDashboardMileageModal.hasValidMileage': 'Quilometratge',

	'fourDiagonalPerspectives.vehicleFrontRight.title': ' ',
	'fourDiagonalPerspectives.vehicleRearRight.title': ' ',
	'fourDiagonalPerspectives.vehicleRearLeft.title': ' ',
	'fourDiagonalPerspectives.vehicleFrontLeft.title': ' ',
	'fourDiagonalPerspectives.vehicleFrontLeft.exampleModalTitle': 'Fotografia exemple',
	'fourDiagonalPerspectives.vehicleRearLeft.exampleModalTitle': 'Fotografia exemple',
	'fourDiagonalPerspectives.vehicleRearRight.exampleModalTitle': 'Fotografia exemple',
	'fourDiagonalPerspectives.vehicleFrontRight.exampleModalTitle': 'Fotografia exemple',

	'completeFourAdditionalPicturesModal.headline': 'Indicació',
	'completeFourAdditionalPicturesModal.description': 'Si us plau afegeix la informació següent:',
	'completeFourAdditionalPicturesModal.hasOverallDashboardImage': 'Foto del tauler frontal',
	'completeFourAdditionalPicturesModal.hasMileageImage': 'Foto del quilometratge',
	'completeFourAdditionalPicturesModal.hasWindshieldImage': 'Foto del parabrisa',
	'completeFourAdditionalPicturesModal.hasVINImage': 'Fotografia del numero VIN (Núm. Xassis)',
	'registrationDocumentExampleModal.headline': 'Fotografia de la carta groga - exemple',
	'vehicleImages.overviewPhotos': 'Fotografies de visió general del vehicle',
	'vehicleImages.overviewPhotos.subtitle': 'Fes les fotos seguint les instruccions.',
	'vehicleImages.description': ' ',
	'vehicleImages.leftFrontOverview': 'Part davantera esquerra del vehicle',
	'vehicleImages.leftRearOverview': 'Part posterior esquerra del vehicle',
	'vehicleImages.rightRearOverview': 'Part posterior dreta del vehicle',
	'vehicleImages.rightFrontOverview': 'Part davantera dreta del vehicle',
	'vehicleImages.details.first': 'Part davantera esquerra del vehicle',
	'vehicleImages.details.second': 'Part posterior esquerra del vehicle',
	'vehicleImages.details.third': 'Part davantera dreta del vehicle',
	'vehicleImages.details.fourth': 'Part posterior dreta del vehicle',
	'overallDashboardImage.headline': 'Imatge general de la part frontal interior del teu vehicle',
	'dashboardMileage.dashboard.title': 'Foto del quilometratge',
	'dashboardMileage.placeholder': 'per exemple, 150000 km',
	'windshieldImage.headline': 'Imatge del parabrisa',
	'vinPicture.headline': 'Fotografia del numero VIN (Núm. Xassis)',
	'waitForAudit.description.damageFound': "T'avisarem tan bon punt es processin les imatges.",
	'fourPerspectivesExampleModal.button.close': 'Tancar',
	'fourPerspectivesExampleModal.headline.first':
		'Fotografies de visió general del vehicle – exemple',
	'imageRecognitionMismatchModal.headline': 'Estàs segur que has afegit la foto adequada?',
	'button.backchangeImage': 'Tornar i canviar la imatge',
	'review.stepDescription.mileage': 'Quilometratge',
	'review.headline.first': 'Comprovar',
	'review.paragraph.first':
		'Assegura\'t que totes les dades estan introduïdes i fes clic a "Completa". Rebràs un resum de les dades introduïdes.',
	'review.stepDescription.vehicleImages': 'Visió general del vehicle',
	'review.stepDescription.vehicleInformation': 'Registre del vehicle ',
	'review.stepDescription.fourAdditionalPictures': 'Imatges addicionals',
	'review.editViewButton': 'View / Edit',
	'review.button.next': 'Següent »',
	'feedback.headline.policyCheck': 'Gràcies per utilitzar PolicyCheck',
	'feedback.description': 'Esperem que hagi estat fàcil i útil per a tu',
	'feedback.rating.policyCheck': 'Com valores PolicyCheck?',
	'feedback.button.send': 'Enviar la teva opinió',
	'feedback.yourOpinion': 'La teva opinió',
	'waitForAudit.thankYou': 'Gràcies',
	'waitforAudit.finish': 'Finalitzar',
	'waitForAudit.description': "T'avisarem tan bon punt es processin les imatges.",
	'completeVehicleImagesModal.headline': 'Indicació',
	'completeVehicleImagesModal.description': 'Si us plau afegeix la informació següent:',
	'completeVehicleImagesModal.hasVehicleImageFrontLeft':
		'Foto de la part davantera esquerra del vehicle',
	'completeVehicleImagesModal.hasVehicleImageRearRight':
		'Foto de la part posterior dreta del vehicle',
	'completeVehicleImagesModal.hasVehicleImageFrontRight':
		'Foto de la part davantera dreta del vehicle',
	'completeVehicleImagesModal.hasVehicleImageRearLeft':
		'Foto de la part posterior esquerra del vehicle',
	'loader.error': "No s'ha pogut carregar el vostre procés. Siusplau, intenta-ho més tard...",
	'mainError.tryAgain': 'torna-ho a provar',
	'thanks.headline.first': 'Gràcies',
	'thanks.paragraph.first': "T'avisarem tan bon punt es processin les imatges.",
	'timeout.bottom': ' ',
	'timeout.headline.first': "L'enllaç a l'aplicació ja no està actiu!",

	'testcasemodal.headline': 'Avís de cas de prova!',
	'testcasemodal.accept': 'Acceptar',
	'testcasemodal.paragraph': 'Tingueu en compte que és un cas de prova!',
	'testcasewarningalert.paragraph': 'Aquest és un cas de prova!',
};

export default messages;
